import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getApiBaseUrl } from '../utils/axios';
import PageMeta from './PageMeta';
import './Blog.css';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/blog`)
      .then(res => res.json())
      .then(data => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const imageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    return `${getApiBaseUrl()}${url}`;
  };

  return (
    <div className="blog-layout">
      <PageMeta
        title="Blog"
        description="Offerte tips, Odoo-integratie en AI voor professionele offertes. Handige artikelen voor ZZP en MKB."
      />
      <header className="blog-header">
        <div className="blog-header-inner">
          <Link to="/welkom" className="blog-logo-link">
            <img src="/logo-offerterunner.png" alt="OfferteRunner" className="blog-logo" />
          </Link>
          <nav className="blog-nav">
            <Link to="/welkom">Home</Link>
            <Link to="/blog" className="active">Blog</Link>
            <Link to="/welkom#pricing">Prijzen</Link>
            <a href="mailto:support@ploko.nl">Contact</a>
          </nav>
        </div>
      </header>

      <main className="blog-main">
        <div className="blog-container blog-list-container">
          <h1 className="blog-title">Blog</h1>
          <p className="blog-intro">
            Tips over offertes maken, Odoo en AI voor professionele offertes. Voor ZZP&apos;ers en het MKB.
          </p>

          {loading ? (
            <p className="blog-loading">Laden...</p>
          ) : posts.length === 0 ? (
            <p className="blog-empty">Nog geen artikelen.</p>
          ) : (
            <ul className="blog-list">
              {posts.map((post) => (
                <li key={post.slug} className="blog-list-item">
                  <Link to={`/blog/${post.slug}`} className="blog-list-link">
                    <div className="blog-list-image-wrap">
                      {post.cover_image_url ? (
                        <img src={imageUrl(post.cover_image_url)} alt="" />
                      ) : (
                        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: '2.5rem' }} aria-hidden>📄</div>
                      )}
                    </div>
                    <div className="blog-list-card-body">
                      <time className="blog-list-date" dateTime={post.date}>
                        {new Date(post.date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}
                      </time>
                      <h2 className="blog-list-title">{post.title}</h2>
                      {post.metaDescription && (
                        <p className="blog-list-desc">{post.metaDescription}</p>
                      )}
                      <span className="blog-list-more">Lees meer →</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>

      <footer className="blog-footer">
        <div className="blog-container">
          <p>
            <Link to="/welkom">OfferteRunner</Link> – Professionele offertes in minuten. Koppeling met Odoo en AI.
          </p>
        </div>
      </footer>
    </div>
  );
}
